import React from "react";
import FaqQuestionsContainer from "containers/Faq/FaqQuestions/index";

const Faq = () => {
  return (
    <>
      <FaqQuestionsContainer />
    </>
  );
};

export default Faq;
